/** FF001 労働者名簿 — omit from generic key dump (shown in custom editor / invitation). */
export const WORKER_REGISTRY_HIDDEN_FIELDS = new Set([
  'careerHistoryListedInResume',
  'hireDate',
  'retirementDate',
  'reasonForDismissal',
  'occupation',
]);

export const WORKER_REGISTRY_SECTION_PREVIOUS_JOB = '当社前職歴';
export const WORKER_REGISTRY_SECTION_EMPLOYMENT = '雇用情報';
